
import curveBg from "../assests/images/card-bg.svg";
import stepperBgImg from "../assests/images/stepperBg.svg";
import styled from "@emotion/styled";
import { createTheme } from "@mui/material/styles";

export const StepperBg = styled.div`
  background-color: #f6fbff;
  background-image: url(${curveBg}), url(${stepperBgImg});
  background-position: bottom left, 100% 100%;
  background-repeat: no-repeat;
  border: 0;
  padding: 70px 0;
  height: calc(100% - 194px);
  width: 100%;
  overflow-y: auto;
  @media (max-width: 767px) {
    background-image:none;
    padding:15px;
    height: calc(100% - 108px);
    width: 100%;
  }
  @media (min-width: 768px) and (max-width: 1180px) {
    padding: 70px 5%;
    background-image:none;
  }
  // img {
  //   height: 35px;
  // }
  .MuiStepLabel-label{
    padding: 0 14px;
  }
  .MuiStepIcon-root.Mui-active,
  .MuiStepLabel-label.Mui-active {
    color: #1468a2;
  }
  .MuiTextField-root,
  .MuiFormControl-root {
    border: 0;
    margin: 0 0 24px 0;
    width: 100%;
  }
  .MuiFormLabel-root {
    font-size: 14px;
    position: static;
    -webkit-transform: none;
    transform: none;
    span {
      font-size: 10px;
      color: #707070;
    }
    .MuiFormLabel-asterisk {
      color: #dc3545;
      font-size: 14px;
    }
  }
  .MuiInputBase-root {
    input {
      font-size: 14px;
      color: #333;
      padding-top: 13px;
      padding-bottom: 13px;
      padding-left: 24px;
    }
    &.MuiFilledInput-root {
      background-color: #e7f4ff;
      border-radius: 5px;
      padding-top:0;
      &:hover {
        &::before {
          border: 0;
        }
      }
    }
    &::before {
      border: 0;
    }
    // .MuiFilledInput-input{
    //   padding:14px 4px
    // }
  }
  .MuiAutocomplete-root{
    .MuiFilledInput-input{
      padding:14px 16px !important;
    }
  }
  .MuiSelect-select {
    font-size: 14px;
    color: #333;
    padding-top: 13px;
    padding-bottom: 13px;
    padding-left: 24px;
  }
  .MuiFormGroup-root {
    .MuiFormControlLabel-label {
      font-size: 14px;
    }
  }
`;

export const theme = createTheme({
  palette: {
    primary: {
      main: "#1468A2",
    },
  },
  typography: {
    fontFamily: ["Poppins, sans-serif"].join(","),
    variants: [],
  },
  components: {
    MuiButton: {
      styleOverrides: {
        // Name of the slot
        root: {
          fontSize: "1rem",
          padding: "9.2px 15px",
          textTransform: "none",
        },
      },
      variants: [
        {
          props: { variant: "contained" },
          style: {
            backgroundColor: "#1468A2",
            width: "240px",
            "&:hover": {
              backgroundColor: "#1468A2",
              color: "#fff",
            },
          },
        },
      ],
    },
    MuiStepIcon: {
      styleOverrides: {
        root: {
          height: "1.3em",
          width: "1.3em",
        },
      },
    },
    MuiStepConnector: {
      styleOverrides: {
        root: {
          top: "15px",
        },
      },
    },
  },
});

theme.typography.h2 = {
  fontSize: 28,
  fontWeight: 600,
  color: "#1468A2",
  lineHeightt: "36px",
  marginBottom: "10px",
};

theme.typography.h3 = {
  fontSize: 18,
  fontWeight: 600,
  color: "#1468A2",
  marginBottom: "1rem",
};